
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/[destinationSlug]/offers",
      function () {
        return require("private-next-pages/destinations/[destinationSlug]/offers.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/[destinationSlug]/offers"])
      });
    }
  